import { ModalAction } from "src/models/ModalAction";
import { createElement, useEffect, useRef, useState } from "react";

const useMountOpenModal = () => {
  const [modal, setModal] = useState<any>(null);
  const ref = useRef<ModalAction | null>(null);

  useEffect(() => {
    if (modal) {
      ref.current?.openModal();
    }
  }, [modal]);

  const createModal = (element: any, props: any) => {
    if (!element) {
      return ref.current?.closeModal();
    }
    return setModal(
      createElement(element, {
        ...props,
        modalRef: ref,
      })
    );
  };

  return [modal, createModal];
};

export default useMountOpenModal;
